import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routers from "./Router";
import { SetAuthToken, SetDefaultHeaders, TOKEN } from "./data/Config";
import useGenFetcher from "./data/useFetcher";
import { useEffect } from "react";

SetDefaultHeaders();

if (localStorage.getItem(TOKEN)) {
	SetAuthToken(localStorage.getItem(TOKEN));
}

function App() {
	let { loadUser } = useGenFetcher();

	useEffect(() => {
		loadUser();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="App">
			<Router>
				<Routers />
			</Router>
		</div>
	);
}

export default App;
